<template>
  <div class="region-app">
    <div
      class="map-wrapper"
      :style="`background-image: url(${mapBackgroundImage()})`"
    >
      <div :class="['map-container']">
        <MapSVG></MapSVG>
      </div>
    </div>
    <div class="map-side">
      <div class="info-boxes">
        <div
          :class="['info-box']"
          v-for="item in regions.nodes"
          :key="item.id"
          ref="infoBoxes"
          :data-id="item.slug"
        >
          <figure v-if="item.featuredImage" class="info-box__figure">
            <img
              width="625"
              class="info-box__img"
              :src="item.featuredImage.node.sourceUrl"
              :alt="item.title"
              :srcset="item.featuredImage.node.srcSet"
              sizes="30vw"
            />
          </figure>
          <div class="info-box__content">
            <h4 class="info-box__heading">{{ item.title }}</h4>
            <div
              v-if="item.weatherHtml"
              class="info-box__weather"
              v-html="item.weatherHtml"
            ></div>
            <div class="drawer__excerpt" v-html="item.excerpt"></div>
            <a :href="item.link" class="btn">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// import MapSVG from './svg/Map.svg'; old version
import MapSVG from './svg/gpd.svg';
import { ALL_LOCATION_DATA } from '../graphql';

// register ScrollTrigger
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default {
  components: {
    MapSVG,
  },
  data: function() {
    return {
      triggerPercentage: 40, // % down the viewport, where the next marker needs to meet to trigger it
      regions: {
        nodes: [],
      },
    };
  },
  apollo: {
    regions: {
      query: ALL_LOCATION_DATA,
    },
  },

  mounted() {
    this.container = document.querySelector('.map-container');

    // eslint-disable-next-line
    const siteUrl = typeof pageInfo !== 'undefined' ? pageInfo.site_url : '';

    const markers = document.querySelectorAll('.map-svg .marker');
    const labels = Array.from(document.querySelectorAll('.map-svg .label'));

    // this.markers = Array.from(markers).sort(
    //   (a, b) => a.dataset.id - b.dataset.id
    // );
    this.markers = Array.from(markers);

    // this.$refs.infoBoxes.forEach((box, index) => {
    this.markers.forEach((marker, index) => {
      // toggle active classes for info boxes
      const toggleClasses = (self) => {
        // disable/activate info box active class (we have to do it in this callback because toggleClass only lets you set a class to one element (which we are already doing for the marker.is-active)
        if (typeof this.$refs.infoBoxes !== 'undefined') {
          const infoBox = this.$refs.infoBoxes.find(
            (b) => b.dataset.id === marker.dataset.id
          );

          if (infoBox) {
            //info box should always exist (except if client has deleted or not created a corresponding region page)
            //infoBox.classList.toggle('is-active');
            if (self.isActive) infoBox.classList.add('is-active');
            // can't use toggle(), because sometime when we load the page and we're already positioned at a particular marker (& the graphql data hasn't loaded yet) the initial toggling on of the is-active class is never run
            else infoBox.classList.remove('is-active');
          }
        }

        labels
          .find((b) => b.dataset.id === marker.dataset.id)
          .classList.toggle('is-active');
      };

      const scrollTrigger = {
        trigger: this.markers[index],
        start: `top ${this.triggerPercentage}%`,
        scrub: true,
        toggleClass: 'is-active', // will be set on the marker that is active
        onEnter: toggleClasses,
        onLeaveBack: toggleClasses,
        onLeave: toggleClasses,
        onEnterBack: toggleClasses,
      };

      if (index + 1 < this.markers.length) {
        scrollTrigger.endTrigger = this.markers[index + 1];
        scrollTrigger.end = `top ${this.triggerPercentage}%`;
      } else {
        scrollTrigger.endTrigger = '.region-app .map-side'; // end the trigger when we no longer see the info box
        scrollTrigger.end = `bottom top`;
      }

      // let clr = "#"+Math.floor(Math.random()*16777215).toString(16);
      // console.warn(clr)
      // scrollTrigger.markers = {startColor: clr, endColor: clr}

      // gsap.from(box, {
      //   scrollTrigger,
      // });

      ScrollTrigger.create(scrollTrigger);

      scrollTrigger.scrub = false;
      scrollTrigger.toggleActions = 'play reset play reset';
      scrollTrigger.onEnter = null;
      scrollTrigger.onLeaveBack = null;
      scrollTrigger.onLeave = null;
      scrollTrigger.onEnterBack = null;

      gsap.to(
        this.markers[index],
        {
          scrollTrigger,
          duration: 1.05,
          autoAlpha: 1,
          scale: 1.6,
          transformOrigin: 'bottom center',
          ease: 'elastic(4.5, 1)',
        },
        0.2
      );

      // -- animate labels
      scrollTrigger.toggleActions = 'play reverse play reverse';

      gsap.to(labels[index], {
        scrollTrigger,
        duration: 0.4,
        scale: 1.15,
        transformOrigin: 'center right',
        //ease: 'elastic(1.5, 1)',
      });
    });

    // ----- add all the click events ( ie when trigger is clicked Scroll to a specific location)

    //gsap.utils.toArray('.map-svg .marker').forEach((a) => {
    gsap.utils.toArray('.map-svg .click').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();

        const targetEl = this.markers.find(
          (m) => m.dataset.id == a.dataset.target
        );

        let targetBox = targetEl.getBBox();

        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: targetEl,
            offsetY:
              (window.innerHeight * this.triggerPercentage) / 100 -
              targetBox.height,
          },
          ease: 'power2',
        });
      });
    });

    // ----- move map to right starting when 40% is off top of screen
    gsap.to('.region-app .map-svg', {
      scrollTrigger: {
        trigger: '.region-app .map-svg',
        start: `40% top`,
        end: 'bottom 50%',
        scrub: true,
        toggleClass: 'active',
      },
      x: '35%',
      ease: 'power1.in',
    });
  },
  methods: {
    mapBackgroundImage() {
      /* eslint-disable no-undef */
      if (
        typeof wisdomRegionMap !== 'undefined' &&
        typeof wisdomRegionMap.map_bkg_image.sizes !== 'undefined'
      )
        return wisdomRegionMap.map_bkg_image.sizes.large;
      /* eslint-enable no-undef */
      return '';
    },
  },
  computed: {},
};
</script>

<style lang="scss">
//TODO remove (just for dev)
// @import url('https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@400;700&display=swap');

// body {
//   margin: 0;
//   line-height: 1.5;
// }
// -- end todod

// -----  LAYOUT POSITIONING

.region-app {
  position: relative;
  max-width: 2000px;
  display: flex;

  .map-wrapper {
    position: relative;
    width: 100%;
    background-color: grey;
    // background-image: url(https://gpd.wisdom.com.au/app/uploads/2021/04/4IkH0G2-scaled.jpg);
    background-position: center center;
    background-size: cover;
    overflow: hidden;

    @media screen and (min-width: 768px) {
      width: 66%;
    }

    @media screen and (min-width: 1025px) {
      background-attachment: fixed;
    }

    //overlay
    &::before {
      content: '';
      background: rgba(0, 0, 0, 0.4);
      position: absolute;
      width: 100%;
      height: 100%;
      display: block;
      top: 0;
    }
  }

  .map-side {
    position: fixed;
    bottom: 0;
    @media screen and (min-width: 768px) {
      position: initial;
      width: 34%;
    }
  }

  .map-svg {
    transform: translateZ(0);
    backface-visibility: hidden;
    display: block;
  }

  .info-boxes {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    display: grid;

    @media screen and (min-width: 768px) {
      padding-top: 50px;
    }
  }

  .info-box {
    grid-area: 1 / 1;
    opacity: 0;
    transition: opacity 0.7s, visibility 0.7s, transform 1s;
    visibility: hidden;
    //border: solid 1px grey;
    padding: 1em;
    transform: translateY(-1em);
    background: rgba(255, 255, 255, 0.95);

    &.is-active {
      opacity: 1;
      visibility: inherit;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 767px) and (orientation: 'portrait') {
    flex-direction: column;

    .map-side {
      position: sticky;
    }

    &.last-active {
      flex-direction: column;
      padding-bottom: initial;
      .map-side {
        position: initial;
      }
      .info-box:last-child {
        opacity: 1;
        visibility: visible;
        transform: none;
      }
    }
  }
}

// ----- COLOURS / ELEMENT DESIGNS

body {
  --wis-color-text: #7a7a7a;
  --wis-color-heading: #101010;
  --wis-color-dark: #101010;
  --wis-color-accent-1: #f291bf;
  --wis-color-cacent-2: #c0f3d6;
}

.region-app {
  font-size: 62.5%;
  color: var(--wis-color-text);
  font-family: 'Lexend Deca', Sans-serif;
  font-weight: 400;

  .marker {
    transition: fill 0.7s;
    //transform: scale(1);

    &.is-active {
      fill: var(--wis-color-accent-1);
    }
  }

  .btn {
    font-family: 'Lexend Deca', Sans-serif;
    font-weight: bold;
    color: #ffffff;
    background-color: var(--wis-color-accent-1);
    border-radius: 0px 0px 0px 0px;
    padding: 1em 2em;
    display: inline-block;
    line-height: 1;
    text-decoration: none;
    transition: background-color 0.3s;

    &:hover {
      background-color: var(--wis-color-dark);
    }
  }

  .info-box {
    display: grid;
    grid-template-columns: calc(35% - 1em) 65%;
    grid-column-gap: 1em;
    margin: 0.7em;
    line-height: 1.1;

    // @media screen and (max-width: 767px) and (orientation: 'portrait') {
    //   display: grid;
    //   grid-template-columns: calc(30% - 1em) 70%;
    //   grid-column-gap: 1em;
    // }

    &__figure {
      margin: 0;
    }

    &__img {
      max-width: 100%;
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &__heading {
      color: var(--wis-color-heading);
      margin: 0.5em 0 1em;
      font-weight: bold;
      font-size: 1em;
    }

    &__weather {
      font-weight: bold;
      color: var(--wis-color-heading);
      margin: 1em 0;

      .svg-icon {
        height: 1.8em;
        width: 1.8em;
        vertical-align: middle;
        margin-right: 0.4em;

        path {
          fill: var(--wis-color-heading);
        }
      }
    }

    @media screen and (min-width: 768px) {
      display: block;
      font-size: min(1.15vw, 1.6em);
      line-height: inherit;

      &__img {
        max-width: 100%;
        display: block;
        max-height: 30vh;
        width: 100%;
        object-fit: cover;
      }

      &__heading {
        font-size: min(1.5vw, 2.2em);
        margin: 1.3em 0 1.1em;
      }
    }
  }

  .label {
    .underline {
      transition: stroke-width 0.8s ease 0.2s;
    }

    &:not(.is-active, :hover) {
      .underline {
        stroke-width: 0px;
      }
    }
  }

  .click {
    cursor: pointer;
    fill: transparent;
  }
}
</style>
